import React, { FC, memo, useCallback, useEffect, useState } from 'react'

import { FocusNode } from '@please/lrud'

import { icons } from '@/constants/icons'
import { SelectPopupProps, SelectProps } from '@/types/componentsPropsTypes'

import { SelectPopup } from './selectPopup'
import { SelectButton } from './styles'

const SelectRaw: FC<SelectProps> = ({ selectOptions, actionComponent }) => {
  const [selectPopup, setSelectPopup] =
    useState<Nullable<SelectPopupProps>>(null)
  const [activeOptionId, setActiveOptionId] = useState<string>()
  const [activeOptionLabel, setActiveOptionLabel] = useState<string>()

  useEffect(() => {
    updateActiveOptionLabel(activeOptionId)
  }, [activeOptionId])

  useEffect(() => {
    setActiveOptionId(selectOptions.selectedOptionId)
  }, [selectOptions])

  const onClick = useCallback(
    (e: LRUDEvent) => {
      setSelectPopup({
        ...selectOptions,
        prevFocusId: e.node.focusId,
        activeOptionId: activeOptionId,
        closeSelectPopup: () => setSelectPopup(null),
        setActiveOptionId: setActiveOptionId,
      })
    },
    [selectOptions, activeOptionId],
  )

  const updateActiveOptionLabel = useCallback(
    (activeOptionId?: string) => {
      const label = selectOptions.selectOptionList.find(
        (option) => option.id === activeOptionId,
      )?.label
      setActiveOptionLabel(label)
    },
    [selectOptions.selectOptionList],
  )

  return (
    <>
      {actionComponent ? (
        <FocusNode onSelected={onClick}>{actionComponent}</FocusNode>
      ) : (
        <SelectButton elementType="button" onSelected={onClick}>
          <div className="label">
            {activeOptionLabel || selectOptions.placeholder}
          </div>
          <div>
            <img src={icons.controls.chevronDown} alt="" />
          </div>
        </SelectButton>
      )}
      {selectPopup && <SelectPopup {...selectPopup} />}
    </>
  )
}

export const Select = memo(SelectRaw)
